import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { components } from 'react-select';
import { FiPlus } from "react-icons/fi";
import { Spin, Tooltip } from 'antd';
import { Box, Stack } from '@mui/material';

import Modal from "../../components/uiComponent/modal/index";
import Input from "../../components/uiComponent/inputs/input/index";
import ReactSelect from '../../components/uiComponent/select';

import { copyToClip } from '../../utils/utils';

import { TableStyleWrapper } from './style';
import { useDispatch, useSelector } from 'react-redux';
import { ClearVendorItemStates, CreateVendorItems, EditVendorItemInfo, GetVendorItems, LinkVendorItem } from '../../slices/vendor-items';
import { GetVendorsList } from '../../slices/po';
import { STORAGE_IMAGE_URL } from '../../constants/storage';

const ProductImg = `${STORAGE_IMAGE_URL}/newImages/nestle.svg`;
const copyIcon = `${STORAGE_IMAGE_URL}/newImages/copy-white-icon.svg`;

const AddVendorEditVendor = ({
  setIsVendorItems,
  editVendor,
  setEditVendor,
  addVendor,
  setAddVendor,
  data,
  isVendorItems,
  createVendorItem,
  setCreateVendorItem,
  editedVendorItem,
  setEditedVendorItem,
  expandRow
}) => {

  const [selectedOption, setSelectedOption] = useState(null);
  const [vendorItemSelectedOption, setVendorItemSelectedOption] = useState(null);
  const dispatch = useDispatch();

  const { vendorsList } = useSelector(state => state.pos);

  const {
    vendorItems,
    linkVendorItemLoading,
    editVendorItemLoading,
    createVendorItemLoading
  } = useSelector(state => state.vendorItems);

  const { currentUser } = useSelector(state => state.auth);

  const options = [
    { value: "apple", label: "Apple" },
    { value: "banana", label: "Banana" },
    { value: "cherry", label: "Cherry" },
  ];
  const handleChange = (selected) => {
    if (!selected) {
      setVendorItemSelectedOption();
      setSelectedOption();
      return;
    }
    const { id } = selected;
    setSelectedOption(selected);
    if (!id) return;
    handleEditVendorItem('vendorId', id);
    handleCreateVendorItem('vendorId', id);
    setVendorItemSelectedOption();
    setEditedVendorItem((prev) => ({
      ...prev,
      'vendorItemId': ''
    }));
    !addVendor && dispatch(GetVendorItems({ vendor_id: id }));
  };

  const clearStates = () => {
    setSelectedOption(null);
    setVendorItemSelectedOption(null);
    setIsVendorItems(false);
    setAddVendor(false);
    setCreateVendorItem({});
    dispatch(ClearVendorItemStates({ field: 'vendorItems', value: [] }))
  }
  const handleVendorItemChange = (selected) => {
    if (!selected) {
      setVendorItemSelectedOption();
      return;
    };
    const { id = null, vendor_item_name } = selected;
    setVendorItemSelectedOption({ id, label: vendor_item_name, value: vendor_item_name });
    if (!id) return;
    handleEditVendorItem('vendorItemId', id);
  };

  const handleEditVendorItem = (key, value) => {
    setEditedVendorItem((prev) => ({
      ...prev,
      [key]: value
    }))
  };

  const handleCreateVendorItem = (key, value) => {
    setCreateVendorItem((prev) => ({
      ...prev,
      [key]: value
    }))
  };

  const createNewVendorItem = () => {
    const body = {
      productId: data?.id,
      ...createVendorItem,
      identifierType: data?.identifier_type,
      identifierValue: data?.identifier_value
    };
    dispatch(CreateVendorItems(body)).then(() => {
      clearStates();
      expandRow(data?.id);
    })
  }

  useEffect(() => {
    if (currentUser?.is_employee_of && !currentUser?.permissions.includes(2)) {
      return
    }
    else {
      dispatch(GetVendorsList());
    }
  }, [currentUser]);

  const handleDisableVendorItem = () => {
    const { vendor_item_name, brand, minimum_order_quantity, case_quantity } = editedVendorItem;

    if (!vendor_item_name || !brand) return true;
    if (minimum_order_quantity && Number(minimum_order_quantity) < 1) return true;
    if (case_quantity && Number(case_quantity) < 1) return true;
    if (minimum_order_quantity != null && isNaN(Number(minimum_order_quantity) || (minimum_order_quantity != null && minimum_order_quantity < 1))) return true;
    if (case_quantity != null && isNaN(Number(case_quantity) || (case_quantity != null && case_quantity < 1))) return true;

    return false;
  };

  const handleCreateVendorItemDisabled = () => {
    const { vendorItemName, brand, moq, caseQuantity } = createVendorItem;

    if (!vendorItemName || !brand) return true;
    if (moq) {
      if (isNaN(Number(moq))) return true;
      if (moq != null && isNaN(Number(moq)) || (moq != null && moq < 1)) return true;
    }
    if (caseQuantity) {
      if (isNaN(Number(caseQuantity))) return true;
      if (caseQuantity != null && isNaN(Number(caseQuantity)) || (caseQuantity != null && caseQuantity < 1)) return true;
    }
    return false;
  };

  const handleLinkVendorItem = () => {
    const { vendorItemId } = editedVendorItem;
    dispatch(LinkVendorItem({
      vendorItemId,
      productId: data?.id
    })).then(() => {
      setIsVendorItems(false);
      clearStates();
      expandRow(data?.id);
    })
  };

  const handleVendorItem = () => {
    const body = {
      vendorItemId: editedVendorItem?.id,
      identifierType: editedVendorItem?.identifier_type,
      identifierValue: editedVendorItem?.identifier_value,
      productId: data?.id || editedVendorItem?.product_id,
      vendorId: editedVendorItem.vendor_id,
      vendorItemName: editedVendorItem?.vendor_item_name,
      brand: editedVendorItem?.brand || editedVendorItem?.brand,
      moq: editedVendorItem?.minimum_order_quantity || editVendor?.minimum_order_quantity,
      caseQuantity: editedVendorItem?.case_quantity || editVendor?.case_quantity
    }
    dispatch(EditVendorItemInfo(body)).then(() => {
      setEditVendor(false);
      clearStates();
      expandRow(data?.id);
    })
  }

  const Options = [
    { value: 'item1', label: 'Vendor Item Name lorme ipsum', upc: '12345678900' },
    { value: 'item2', label: 'Vendor Item Name lorme ipsum', upc: '12345678900' },
    { value: 'item3', label: 'Vendor Item Name lorme ipsum', upc: '12345678900' },
  ];

  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{ padding: '10px', borderBottom: '1px solid #e0e0e0' }}
      >
        <div style={{ fontSize: '12px', fontWeight: '400', color: '#535E63' }}>{data?.vendor_item_name || '-'}</div>
        <div style={{ fontSize: '10px', fontWeight: '400', color: '#808183' }}>{data?.identifier_type || '-'} / {data?.identifier_value || '-'}</div>
      </div>
    );
  };

  const CustomMenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <p onClick={() => setAddVendor(true)} className="add-vendor-btn-wrapper">
          <FiPlus /> Create Vendor Item
        </p>
      </components.MenuList>
    );
  };

  return (
    <div>
      <Modal
        open={isVendorItems}
        onHide={() => {
          clearStates();
        }}
        buttonDisabled={
          !addVendor ?
            !selectedOption?.id || !vendorItemSelectedOption || linkVendorItemLoading :
            !selectedOption?.id || handleCreateVendorItemDisabled() || createVendorItemLoading
        }
        className="vendor-modal-wrapper-ui"
        closeText="Cancel"
        saveText="Save"
        header={true}
        removeIcon
        closeButton={false}
        onClose={() => {
          clearStates();
        }}
        onSave={() => {
          if (addVendor) {
            createNewVendorItem();
          } else {
            handleLinkVendorItem();
          }
        }}
      >
        <TableStyleWrapper>
          <div className="card-item-wrapper">
            <h6>{addVendor ? 'Create Vendor Item' : 'Map Vendor Item'}</h6>
            <div className="product-title">
              <img src={data?.image_url || ProductImg} alt="product" width={28} height={28} className='product-img' />
              <div className='w-100'>
                <Tooltip placement="bottom" title={''}>
                  <span className="product-name">{data?.name || 'N/A'}</span>
                </Tooltip>
                <div className='d-flex align-items-center gap-2'>
                  <div className='asin sku'>
                    <span>{data?.identifier_type || 'N/A'} <span>{data?.identifier_value || 'N/A'}</span></span>
                    <img src={copyIcon} alt='copy' className='cursor-pointer'
                      onClick={() => copyToClip(data?.identifier_value || 'N/A')} />
                  </div>
                </div>
              </div>
            </div>
            {!addVendor ? (
              <Spin tip='Mapping..' spinning={linkVendorItemLoading}>
                <Box marginTop={1.5} display="grid" gap={3} alignItems="center" gridTemplateColumns="1fr 1fr">
                  <ReactSelect
                    label="Vendor"
                    options={vendorsList}
                    important
                    value={selectedOption}
                    onChange={handleChange}
                    placeholder="Choose Vendor..."
                    isClearable={true}
                    className="vendor-select-wrapper"
                  />
                  <div style={{ width: '100%' }}>
                    <label style={{ fontSize: '12px', color: '#8a9ab0' }}>
                      Select Vendor Item <span style={{ color: 'red' }}>*</span>
                    </label>
                    <Select
                      options={vendorItems}
                      placeholder="Select"
                      className="vendor-select-wrapper"
                      onChange={handleVendorItemChange}
                      value={vendorItemSelectedOption}
                      components={{
                        Option: CustomOption,
                        MenuList: CustomMenuList,
                      }}
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderRadius: '8px',
                          borderColor: '#e0e0e0',
                          padding: '0px',
                          boxShadow: 'none',
                          '&:hover': { borderColor: '#c0c0c0' },
                        }),
                        menu: (base) => ({
                          ...base,
                          borderRadius: '8px',
                          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
                        }),
                      }}
                    />
                  </div>
                </Box>
              </Spin>
            )
              :
              (
                <Spin tip='Creating..' spinning={createVendorItemLoading}>
                  <Box>
                    <Stack marginTop={1.5} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                      <ReactSelect
                        label="Vendor"
                        options={vendorsList}
                        important
                        value={selectedOption}
                        onChange={handleChange}
                        placeholder="Choose Vendor"
                        isClearable={true}
                        className="vendor-select-wrapper"
                      />
                      {/* <ReactSelect
                      label="Select Vendor Item"
                      options={vendorItems}
                      important
                      // value={vendorItemSelectedOption}
                      onChange={handleVendorItemChange}
                      placeholder="Choose Vendor Item"
                      isClearable={true}
                      className="vendor-select-wrapper"
                    /> */}
                      <Input
                        label="Identifier"
                        overlayClassName="input-vendor-add"
                        placeholder={data?.identifier_type || ''}
                        value={data?.identifier_type || ''}
                        disabled
                        onChange={(e) => {
                          handleCreateVendorItem('identifierType', e.target.value)
                        }}
                      />
                    </Stack>
                    <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                      <Input
                        label="Identifier value"
                        important
                        overlayClassName="input-vendor-add"
                        placeholder={data?.identifier_value || ''}
                        value={data?.identifier_value || ''}
                        disabled
                        onChange={(e) => {
                          handleCreateVendorItem('identifierValue', e.target.value)
                        }}
                      />
                      <Input
                        label="Item Name"
                        important
                        overlayClassName="input-vendor-add"
                        placeholder={createVendorItem?.vendorItemName || ''}
                        value={createVendorItem?.vendorItemName || ''}
                        onChange={(e) => {
                          handleCreateVendorItem('vendorItemName', e.target.value)
                        }}
                      />
                    </Stack>
                    <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                      <Input
                        label="Brand"
                        important
                        overlayClassName="input-vendor-add"
                        placeholder={createVendorItem?.brand || ''}
                        value={createVendorItem?.brand || ''}
                        onChange={(e) => {
                          handleCreateVendorItem('brand', e.target.value)
                        }}
                      />
                      <Input
                        label="MOQ (Minimum Order Qty)"
                        overlayClassName="input-vendor-add"
                        placeholder={createVendorItem?.moq || ''}
                        value={createVendorItem?.moq || ''}
                        type='number'
                        onChange={(e) => {
                          handleCreateVendorItem('moq', e.target.value)
                        }}
                      />
                    </Stack>
                    <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                      <Input
                        label="Case Qty"
                        overlayClassName="input-vendor-add"
                        placeholder={createVendorItem?.caseQuantity || ''}
                        value={createVendorItem?.caseQuantity || ''}
                        type='number'
                        onChange={(e) => {
                          handleCreateVendorItem('caseQuantity', e.target.value)
                        }}
                      />
                    </Stack>
                  </Box>
                </Spin>
              )}
          </div>
        </TableStyleWrapper>
      </Modal>
      <Modal
        open={editVendor}
        onHide={() => {
          setEditVendor(false);
          clearStates();
        }}
        closeText="Cancel"
        saveText={editVendorItemLoading ? 'Saving..' : 'Save'}
        className="vendor-modal-wrapper-ui"
        header={true}
        buttonDisabled={handleDisableVendorItem() || editVendorItemLoading}
        removeIcon
        closeButton={false}
        onClose={() => {
          setEditVendor(false)
          clearStates();
        }}
        onSave={() => {
          handleVendorItem();
        }}
      >
        <TableStyleWrapper>
          <div className="card-item-wrapper">
            <h6>Edit Vendor Item</h6>
            <div className="product-title">
              <img src={data.image_url || ProductImg} alt="product" width={28} height={28} className='product-img' />
              <div className='w-100'>
                <Tooltip placement="bottom" title={data?.name || 'N/A'}>
                  <span className="product-name">{data?.name || 'N/A'}</span>
                </Tooltip>
                <div className='d-flex align-items-center gap-2'>
                  <div className='asin sku'>
                    <span>{data?.identifier_type || 'N/A'} <span>{data?.identifier_value || 'N/A'}</span></span>
                    <img src={copyIcon} alt='copy' className='cursor-pointer'
                      onClick={() => copyToClip(data?.identifier_value)} />
                  </div>
                </div>
              </div>
            </div>
            <Box>
              <Stack marginTop={1.5} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Vendor"
                  overlayClassName="input-vendor-add"
                  disabled
                  placeholder={editedVendorItem?.vendor_name || 'VendorName'}
                  value={editedVendorItem?.vendor_name || 'VendorName'}
                />
                <Input
                  label="Identifier"
                  overlayClassName="input-vendor-add"
                  disabled
                  placeholder={editedVendorItem?.identifier_type || ''}
                  value={editedVendorItem?.identifier_type || ''}
                />
              </Stack>
              <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Identifier Value"
                  overlayClassName="input-vendor-add"
                  disabled
                  placeholder={editedVendorItem?.identifier_value || 'N/A'}
                  value={editedVendorItem?.identifier_value || 'N/A'}
                />
                <Input
                  label="Item Name"
                  important
                  overlayClassName="input-vendor-add"
                  placeholder={editedVendorItem?.vendor_item_name || 'Enter'}
                  value={editedVendorItem?.vendor_item_name || ''}
                  onChange={(e) => {
                    handleEditVendorItem('vendor_item_name', e.target.value)
                  }}
                />
              </Stack>
              <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Brand"
                  important
                  overlayClassName="input-vendor-add"
                  placeholder={editedVendorItem?.brand || editedVendorItem?.brand || 'Enter'}
                  value={editedVendorItem?.brand || editedVendorItem?.brand || ''}
                  onChange={(e) => handleEditVendorItem('brand', e.target.value)}
                />
                <Input
                  label="MOQ (Minimum Order Qty)"
                  overlayClassName="input-vendor-add"
                  type='number'
                  placeholder={editedVendorItem?.minimum_order_quantity || editedVendorItem?.minimum_order_quantity || 'Enter'}
                  value={editedVendorItem?.minimum_order_quantity || editedVendorItem?.minimum_order_quantity || ''}
                  onChange={(e) => handleEditVendorItem('minimum_order_quantity', e.target.value)}

                />
              </Stack>
              <Stack marginTop={3} display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                <Input
                  label="Case Qty"
                  type='number'
                  overlayClassName="input-vendor-add"
                  placeholder={editedVendorItem?.case_quantity || editedVendorItem?.case_quantity || 'Enter'}
                  value={editedVendorItem?.case_quantity || editedVendorItem?.case_quantity || ''}
                  onChange={(e) => handleEditVendorItem('case_quantity', e.target.value)}
                />
              </Stack>
            </Box>
          </div>
        </TableStyleWrapper>
      </Modal>
    </div>
  )
}

export default AddVendorEditVendor
